import { z } from "zod/v4";

import { VariationDtoSchema } from "../../../../dtos/variations";
import { PluginOnsiteEditSchema } from "../onsite-edits";
import { PluginUserInterfaceType_2024_05_05 } from "../userInterfaces";

export const PluginVariationSchema_2024_05_05 = VariationDtoSchema.omit({
  offer: true,
  includeProducts: true,
  excludeProducts: true,
  functionSyncError: true,
  redirects: true,
  userInterfaces: true,
}).extend({
  onsiteEdits: z.optional(PluginOnsiteEditSchema.array()),
});

export type PluginVariationType_2024_05_05 = z.infer<
  typeof PluginVariationSchema_2024_05_05
> & {
  isExcluded?: boolean;
};
export type PluginVariationType = PluginVariationType_2024_05_05;
